import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Grid, TableCell } from "@material-ui/core";
import useCellStyles from "./styles";
import { IColumn } from "./";

interface HeadCellProps {
  children: any;
  columnData?: IColumn;
  headerHeight: number;
  fixedSize?: boolean;
  className?: string;
  style?: any;
}

export const HeadCell = ({
  children,
  columnData,
  headerHeight,
  fixedSize = false,
  className = "",
  style = {},
}: HeadCellProps) => {
  const classes = useCellStyles();
  const align = columnData?.align || "left";
  const width = columnData?.width || 96;
  const subColumns = columnData?.subColumns || [];
  const Component = columnData?.headComponent;
  let customStyle = fixedSize ? { minWidth: width, maxWidth: width } : {};

  return (
    <TableCell
      component="div"
      className={clsx(classes.tableHeadCell, className, {
        [classes.tableHeadCellWithGroup]: Boolean(subColumns.length),
      })}
      variant="head"
      style={{ ...style, ...customStyle, height: headerHeight }}
      align={align}
    >
      {Component ? (
        <Component columnData={columnData} data={children} />
      ) : (
        <span>{children}</span>
      )}
      <HeadGroupCell columns={subColumns} />
    </TableCell>
  );
};

HeadCell.propTypes = {
  children: PropTypes.node,
};

export const HeadGroupCell = ({ columns }: { columns: any }) => {
  return (
    <Grid container style={{ fontSize: "0.7rem", lineHeight: "0.8rem" }}>
      {columns.map((column, index) => (
        <Grid key={index} item style={{ width: column.width }}>
          <span>{column.label}</span>
        </Grid>
      ))}
    </Grid>
  );
};
